export enum OnCallSpecialistTypes {
  LIST = '@onCallSpecialist/LIST',
  LIST_SUCCESS = '@onCallSpecialist/LIST_SUCCESS',
  LIST_FAILED = '@onCallSpecialist/LIST_FAILED',
}
